var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.5V15.5H19V21.5H25V12.5C25.0001 12.4015 24.9807 12.3039 24.9431 12.2129C24.9055 12.1218 24.8503 12.0391 24.7806 11.9694L17.2806 4.46939C17.211 4.39965 17.1283 4.34433 17.0372 4.30659C16.9462 4.26885 16.8486 4.24942 16.75 4.24942C16.6514 4.24942 16.5538 4.26885 16.4628 4.30659C16.3717 4.34433 16.289 4.39965 16.2194 4.46939L8.71938 11.9694C8.64975 12.0391 8.59454 12.1218 8.5569 12.2129C8.51926 12.3039 8.49992 12.4015 8.5 12.5V21.5H14.5Z",
    fill: "#263322",
    stroke: "#263322",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 12.75 35.25)",
    fill: "#263322"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.75 1.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelected);
export default __webpack_public_path__ + "static/media/HomeSelected.54b01b7275b1f9ffd478b2f842c764d7.svg";
export { ForwardRef as ReactComponent };